export default __webpack_public_path__ + "static/media/up.032b8009.svg";